export default {
  frontRoutes: [
    {
      path: "/test/detail",
      name: "TestDetail",
      component: () =>
        import(/* webpackChunkName: "exam" */ "../views/test/TestDetail.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/test/report/:id",
      name: "TestReport",
      component: () =>
        import(/* webpackChunkName: "exam" */ "../views/test/TestReport.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/test/newReport",
      name: "NewReport",
      component: () =>
        import(/* webpackChunkName: "exam" */ "../views/test/NewReport.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/test/do",
      name: "TestDo",
      component: () =>
        import(/* webpackChunkName: "exam" */ "../views/test/TestDo.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/test/analysis/:id",
      name: "TestAnalysis",
      component: () =>
        import(/* webpackChunkName: "exam" */ "../views/test/TestAnalysis.vue"),
      meta: {
        requireAuth: true,
      },
    },
  ],
  memberRoutes: [
    {
      path: "/member/test",
      name: "MemberTest",
      component: () =>
        import(
          /* webpackChunkName: "classes" */ "../views/member/MemberTest.vue"
        ),
      meta: {
        requireAuth: true,
        title: "考试中心",
        root: true,
      },
    },
  ],
};
